import { Component, effect, inject, OnInit, signal } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { NgxSonnerToaster } from 'ngx-sonner';
import { DesktopMessageComponent } from "./shared/desktop-message/desktop-message.component";
import { LoaderComponent } from "./shared/loader/loader.component";
import { LoaderService } from './services/loader.service';
import { ButtonHelpComponent } from './shared/button-help/button-help.component';
import { HelpService } from './services/help.service';
import { environment } from '@env/environment';
import { VersionCheckService } from './services/version-check.service';
import { filter, Subscription } from 'rxjs';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NgxSonnerToaster, DesktopMessageComponent, LoaderComponent, ButtonHelpComponent],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App implements OnInit{

  colorOne = environment.colorOne;
  colorTwo = environment.colorTwo;

  protected title = 'Vinculaciones Fincomercio';
  isMobile = signal<boolean>(false);

  _loaderService = inject(LoaderService);
  _helpService = inject(HelpService);
  _router = inject(Router);

  private routerSubscription: Subscription | null = null;

  constructor(private versionCheck: VersionCheckService) {
  }

  ngOnInit() {
    this.checkDevice();
    window.addEventListener('resize', () => this.checkDevice());
    this.setGlobalColors();
    this.versionCheck.checkForUpdates();
    this.routerSubscription = this._router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.versionCheck.checkForUpdates();
    });
  }

  checkDevice() {
    this.isMobile.set(window.matchMedia('(max-width: 768px)').matches);
  }

  protected desktopMessageRouteKeys(): string[] {
    const url = this._router.url;
    const show =
      !this.isMobile() &&
      !url.includes('whatsapp') &&
      url !== '/' &&
      url !== '/app/basic';
    return show ? [url] : [];
  }

  private setGlobalColors() {
    document.documentElement.style.setProperty('--gradient-from', this.colorOne);
    document.documentElement.style.setProperty('--gradient-to', this.colorTwo);
    document.documentElement.style.setProperty('--color-primary', this.colorOne);
    document.documentElement.style.setProperty('--color-secondary', this.colorTwo);
  }

}
